import axios from 'axios';

const isProd = process.env.NODE_ENV === 'production';
const baseURL = isProd ? '/api' : 'https://pensionesaps.com.mx/api';

const apsApi = axios.create({
  baseURL,
  timeout: 8000,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
});

export async function fetchPartners() {
  const { data } = await apsApi.get('/public/partners');
  return data;
}

export async function fetchServicios() {
  const { data } = await apsApi.get('/public/servicios');
  return data;
}

export async function fetchSiteConfig() {
  const { data } = await apsApi.get('/public/site-config');
  return data;
}

export default apsApi;
